module.exports = __webpack_public_path__ + "img/Evidence.6cdaca4c.png";